import {useMemo} from 'react';
import {TSupportVideos} from '../../../../redux/management/management.type';

interface FilteredVideos {
    currentPageVideos: TSupportVideos[];
    otherVideos: TSupportVideos[];
}

function useFilteredVideos(videos: TSupportVideos[], pageType: string, isShowingAll: boolean): FilteredVideos {
    return useMemo(() => {
        if (!isShowingAll) {
            return {currentPageVideos: videos, otherVideos: []};
        }
        return videos.reduce<FilteredVideos>((result, video) => {
            const key = video.page.includes(pageType) ? 'currentPageVideos' : 'otherVideos';
            result[key].push(video);
            return result;
        }, {currentPageVideos: [], otherVideos: []});
    }, [videos, isShowingAll, pageType]);
}

export default useFilteredVideos;
